import React from "react";
import PropTypes from "prop-types";
import Button from "wonderbly-components/lib/Button";
import CloseIcon from "wonderbly-components/lib/CloseIcon";

const SaveForLaterConfirm = (props) => (
  <div className="SaveForLaterModal__inner">
    <div className="SaveForLaterModal__header">
      <CloseIcon onHandleClick={props.onHandleClose} color="#00294C" />
    </div>
    <h4 className="SaveForLaterModal__title">{props.title}</h4>
    <p>{props.description}</p>
    <Button onClick={props.onHandleClose}>{props.ctaText}</Button>
  </div>
);

SaveForLaterConfirm.propTypes = {
  isFixed: PropTypes.bool,
  completedDrawersMap: PropTypes.shape({
    all: PropTypes.arrayOf(PropTypes.string.isRequired),
    complete: PropTypes.arrayOf(PropTypes.string.isRequired),
    incomplete: PropTypes.arrayOf(PropTypes.string.isRequired),
  }),
  title: PropTypes.string,
  description: PropTypes.string,
  onHandleClose: PropTypes.func,
  ctaText: PropTypes.string,
};

export default SaveForLaterConfirm;
